import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export {
  branchListPath,
  getStoredBranchId,
  setStoredBranchId,
  useBranchIdParam,
} from '../branch-settings/branchSettingsState.js';
export {
  productListPath,
  productEditorPath,
  bulkImportPath,
  setStoredProductId,
  useProductIdParam,
} from '../catalogue/catalogueState.js';

export function stockOverviewPath(
  branchId?: string,
  extra?: { flash?: string; snooze?: string },
): string {
  const params = new URLSearchParams();
  if (branchId) params.set('branchId', branchId);
  if (extra?.flash) params.set('flash', extra.flash);
  if (extra?.snooze) params.set('snooze', extra.snooze);
  const query = params.toString();
  return query ? `/stock-overview?${query}` : '/stock-overview';
}

export function stockAdjustPath(branchId: string, itemId?: string): string {
  const params = new URLSearchParams({ branchId });
  if (itemId) params.set('itemId', itemId);
  return `/stock-adjust?${params.toString()}`;
}

export function snoozeItemPath(branchId: string, productId?: string): string {
  const params = new URLSearchParams({ branchId });
  if (productId) params.set('productId', productId);
  return `/snooze-item?${params.toString()}`;
}

export function bulkAvailabilityPath(branchId?: string, productIds?: string[]): string {
  const params = new URLSearchParams();
  if (branchId) params.set('branchId', branchId);
  if (productIds?.length) params.set('productIds', productIds.join(','));
  const query = params.toString();
  return query ? `/bulk-availability?${query}` : '/bulk-availability';
}

export function lowStockAlertsPath(branchId?: string): string {
  return branchId
    ? `/low-stock-alerts?branchId=${encodeURIComponent(branchId)}`
    : '/low-stock-alerts';
}

export function batchAndExpiryPath(branchId?: string): string {
  return branchId
    ? `/batch-and-expiry?branchId=${encodeURIComponent(branchId)}`
    : '/batch-and-expiry';
}

export function stocktakePath(branchId?: string): string {
  return branchId ? `/stocktake?branchId=${encodeURIComponent(branchId)}` : '/stocktake';
}

export function useItemIdParam(): string | null {
  const [params] = useSearchParams();
  return params.get('itemId');
}

/** 07-03: history entry so Back closes the snooze overlay on stock overview. */
export function useSnoozeProductParam(): string | null {
  const [params] = useSearchParams();
  return params.get('snooze');
}

export function useFlashItemParam(): string | null {
  const [params] = useSearchParams();
  return params.get('flash');
}

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

export function useProductIdsParam(): string[] {
  const [params] = useSearchParams();
  const raw = params.get('productIds');
  if (!raw) return [];
  return raw
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
}
